import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./styles.scss";
import { Icon } from "@/components";
import { Button } from "../register/register";

export const Welcome = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { token, refreshToken, result } = location.state || {};

  const handleContinue = async () => {
    localStorage.setItem("pluri_token", token);
    localStorage.setItem("pluri_refresh_token", refreshToken);
    localStorage.setItem("user_detail", JSON.stringify(result));
    navigate("/home");
  };

  return (
    <div className="welcome-container">
      <div className="welcome-wrapper">
        <Icon name="logo" />
        <div>
          <h1 className="main-text">Welcome</h1>
        </div>
        <div>
          <p className="sub-text">
            Your profile has been created successfully.
          </p>
        </div>
      </div>
      <Button
        style={{ backgroundColor: "white", color: "#169fed" }}
        title="Continue"
        onPress={handleContinue}
      />
    </div>
  );
};
